import { useLingui } from '@lingui/react/macro'
import Timelock from 'abis/Timelock'
import TransactionButton from '@/components/ui/transaction-button'
import useContractWrite from 'hooks/useContractWrite'
import useWatchTransaction from 'hooks/useWatchTransaction'
import { useAtomValue } from 'jotai'
import { chainIdAtom, rTokenGovernanceAtom, walletAtom } from 'state/atoms'
import { getProposalStateAtom, timelockIdAtom } from '../atom'
import { keccak256, toBytes } from 'viem'
import { useReadContract } from 'wagmi'

const ProposalCancel = () => {
  const { t } = useLingui()
  const governance = useAtomValue(rTokenGovernanceAtom)
  const timelockId = useAtomValue(timelockIdAtom)
  const account = useAtomValue(walletAtom)
  const chainId = useAtomValue(chainIdAtom)
  const { deadline } = useAtomValue(getProposalStateAtom)

  const { data: canCancel } = useReadContract({
    address: governance.timelock,
    abi: Timelock,
    functionName: 'hasRole',
    args: account ? [keccak256(toBytes('CANCELLER_ROLE')), account] : undefined,
    chainId,
  })

  const { write, isLoading, hash, isReady } = useContractWrite({
    abi: Timelock,
    address: governance?.timelock,
    functionName: 'cancel',
    args: timelockId ? [timelockId] : undefined,
    query: { enabled: canCancel },
  })

  const { isMining, status } = useWatchTransaction({
    hash,
    label: 'Proposal canceled',
  })

  if (!deadline || deadline <= 0) return null

  return (
    <TransactionButton
      variant="destructive"
      size="sm"
      loading={isMining || isLoading}
      mining={isMining}
      disabled={!isReady || !canCancel || status === 'success'}
      onClick={write}
      text={t`Cancel proposal`}
      className={`h-11 bg-transparent border ${
        account ? 'border-destructive text-destructive hover:text-destructive-foreground disabled:border-border disabled:text-muted-foreground' : 'border-primary'
      }`}
    />
  )
}

export default ProposalCancel
